import _objectSpread from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { initLogin } from '@/api/index';
import { parseUrl } from '@/utils/tools';
import cache from '@/utils/cache';
import '@/utils/buildwebBridge';
export default {
  data: function data() {
    return {
      renderStart: false,
      configValid: true // 获取自定义背景异常

    };
  },
  computed: _objectSpread({}, mapGetters(['appConfig'])),
  created: function created() {
    // 首次密码登录初始化设置
    if (cache.get('enablePasswordLogin') !== true && cache.get('enablePasswordLogin') !== false) {
      cache.set('enablePasswordLogin', true);
    }

    this.ssoInit();
    this.addNetworkListener();
  },
  methods: {
    /**
     * @func sso初始化
     */
    ssoInit: function ssoInit() {
      var _this = this;

      var _ref = parseUrl(window.location.href) || {},
          _ref$service = _ref.service,
          service = _ref$service === void 0 ? '' : _ref$service,
          _ref$syscode = _ref.syscode,
          syscode = _ref$syscode === void 0 ? '' : _ref$syscode;

      var env = process.env.VUE_APP_MODE;
      initLogin({
        returnUrl: service,
        syscode: syscode
      }).then(function (res) {
        var _ref2 = res || {},
            code = _ref2.code,
            _ref2$data = _ref2.data,
            data = _ref2$data === void 0 ? {} : _ref2$data;

        if (code === '1') {
          startLinkInitPc(env); // 用户未登录, 渲染登录页面

          _this.$store.commit('init/SET_SERVICE_URL', ''); // 存储页面自定义数据，如背景图，主题色，文案、支持密码登录等


          _this.$store.commit('init/SET_APP_CONFIG', data); // 更新缓存


          cache.set('enablePasswordLogin', typeof data.enablePasswordLogin === 'boolean' ? data.enablePasswordLogin : true);
        } else if (code === '301') {
          // 已登陆，记录服务目标地址
          console.log('has logined; write url', data);

          _this.$store.commit('init/SET_SERVICE_URL', data);
        }
      }).catch(function (e) {
        _this.$store.commit('init/SET_SERVICE_URL', '');
      }).finally(function () {
        _this.renderStart = true;
      });
    },

    /**
     * @func 监听网络，维护到状态管理机
     */
    addNetworkListener: function addNetworkListener() {
      var _this2 = this;

      // 联网
      window.addEventListener('online', function () {
        console.log('~~~~~网络已恢复~~~~~');

        _this2.$store.dispatch('network/updateOnlineStatus', true);
      }); // 断网

      window.addEventListener('offline', function () {
        console.log('~~~~~断网断开连接~~~~~');

        _this2.$store.dispatch('network/updateOnlineStatus', false);
      });
    },

    /**
     * @func 处理自定义图片访问不可达场景
     */
    handleImgLoad: function handleImgLoad() {
      this.$store.commit('init/SET_APPCONFIG_VALID', true);
      this.$refs.app.style.background = "url(".concat(this.appConfig.backgroundUrl, ") no-repeat");
      this.$refs.app.style.backgroundSize = '100% 100%';
      this.configValid = true;
    },

    /**
     * @func 处理自定义图片访问不可达场景
     */
    handleImgError: function handleImgError() {
      this.$store.commit('init/SET_APPCONFIG_VALID', false);
      this.configValid = false;
    }
  }
};